<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        cập nhật thông tin kiểm hàng
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="() => (dialog = false)">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-6">
        <v-form ref="form">
          <v-text-field
            v-model="data.billCode"
            :rules="[$rules.required]"
            class="required"
            label="Mã hóa đơn"
            dense
            outlined
          ></v-text-field>
          <v-text-field v-model="data.doCode" label="Mã phiếu / DO" dense outlined></v-text-field>
          <v-text-field v-model="data.poCode" label="Mã đơn / PO" dense outlined></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$auth.policies['import-checks:update-product']"
          @click="onSaveUpdate"
          class="ma-2"
          dark
          depressed
          color="#0D47A1"
          ><v-icon>check</v-icon>Xác nhận thông tin</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddProductButton',
  data() {
    return {
      dialog: false,
      data: {
        billCode: '',
        doCode: '',
        poCode: ''
      },
      obj: {}
    }
  },
  methods: {
    ...mapActions({
      updateAuditModelCode: 'auditProducts/updateAuditModelCode'
    }),
    openDialog(item) {
      if (item) {
        this.obj = item
        this.dialog = true
      }
    },
    refresh() {
      this.$emit('refresh')
    },
    async onSaveUpdate() {
      try {
        const isFormValid = await this.$refs.form.validate()
        if (isFormValid) {
          await this.updateAuditModelCode({
            ...this.data,
            listModel: [this.obj._id],
            importCheck: this.$route.params.id
          })
          this.$emit('onUpdateSuccess')
          this.$alert.success('Cập nhập thành công')
          this.dialog = false
        } else this.$alert.error('Vui lồng điền mã hoá đơn')
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra vui lòng thử lại')
      } finally {
        this.dialog = false
      }
    }
  }
}
</script>
